import { parseApiErrorResponse } from '@/utils/apiErrorResponse';

/**
 * Pulls a field-scoped validation message out of a 400/422 so it can be shown against the input
 * that caused it rather than as an anonymous toast.
 */
export const fieldValidationMessage = (error: unknown, field: string): string | undefined => {
  const { details, status } = parseApiErrorResponse(error);
  if (status !== 400 && status !== 422) {
    return undefined;
  }
  return details.find((detail) => detail.field === field)?.messages[0];
};
